import React, { useEffect } from "react";
import dialog from "../../assets/images/New folder/VVVVVVVVVVV.png";
import close from "../../assets/images/New folder/close.png";
import { useTranslation } from "react-i18next";

const Dialog = ({ isOpen, closeDialog, description }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") closeDialog();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [closeDialog]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-[999999] p-5"
      style={{ background: "rgba(0,0,0,0.85)", backdropFilter: "blur(8px)" }}
      onClick={closeDialog}
    >
      <div
        className="relative w-full"
        style={{
          maxWidth: "360px",
          animation:
            "dialogSlideUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Outer glow ring */}
        <div
          className="absolute inset-0 rounded-3xl pointer-events-none"
          style={{
            boxShadow:
              "0 0 40px rgba(255,238,64,0.25), 0 0 80px rgba(255,238,64,0.1)",
            borderRadius: "24px",
          }}
        />

        {/* Card */}
        <div
          className="relative rounded-3xl overflow-hidden"
          style={{
            background:
              "linear-gradient(160deg, #4a2a1a 0%, #2a1508 50%, #1a0e05 100%)",
            border: "1.5px solid rgba(255,238,64,0.35)",
          }}
        >
          {/* Top decorative strip */}
          <div
            className="w-full h-1"
            style={{
              background:
                "linear-gradient(90deg, transparent, #FFEE40, #f0c45a, transparent)",
            }}
          />

          {/* Background image */}
          <div className="relative">
            <img
              src={dialog}
              alt="dialog"
              className="w-full h-auto object-cover"
              style={{
                filter: "brightness(0.5) saturate(0.8)",
                maxHeight: "180px",
                objectFit: "cover",
              }}
            />
            {/* Image overlay gradient */}
            <div
              className="absolute inset-0"
              style={{
                background:
                  "linear-gradient(to bottom, rgba(24,10,3,0.2), rgba(24,10,3,0.85))",
              }}
            />

            {/* Title over image */}
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              {/* Decorative icon */}
              <div
                className="w-12 h-12 rounded-full flex items-center justify-center mb-2"
                style={{
                  background: "linear-gradient(135deg, #FFEE40, #f0a020)",
                  boxShadow: "0 4px 20px rgba(255,238,64,0.5)",
                }}
              >
                <span style={{ fontSize: "22px" }}>📜</span>
              </div>
              <h2
                className="text-2xl font-black tracking-widest uppercase"
                style={{
                  color: "#FFEE40",
                  textShadow:
                    "0 2px 12px rgba(0,0,0,0.8), 0 0 30px rgba(255,238,64,0.4)",
                  letterSpacing: "0.15em",
                }}
              >
                {t("Rules")}
              </h2>
              {/* Underline accent */}
              <div
                className="mt-1.5 rounded-full"
                style={{
                  width: "48px",
                  height: "2px",
                  background:
                    "linear-gradient(90deg, transparent, #FFEE40, transparent)",
                }}
              />
            </div>
          </div>

          {/* Description area */}
          <div className="px-5 py-5">
            <div
              className="rounded-2xl p-4 overflow-y-auto"
              style={{
                background: "rgba(0,0,0,0.35)",
                border: "1px solid rgba(255,238,64,0.15)",
                maxHeight: "160px",
                /* Custom scrollbar */
                scrollbarWidth: "thin",
                scrollbarColor: "rgba(255,238,64,0.4) transparent",
              }}
            >
              <p
                className="text-sm leading-relaxed text-center"
                style={{
                  color: "rgba(255,238,64,0.9)",
                  fontWeight: "500",
                  lineHeight: "1.7",
                }}
              >
                {description}
              </p>
            </div>

            {/* Dot row */}
            <div className="flex justify-center gap-2 mt-4">
              {[0, 100, 200].map((delay) => (
                <div
                  key={delay}
                  className="rounded-full"
                  style={{
                    width: "6px",
                    height: "6px",
                    background: "#FFEE40",
                    animation: `dotPulse 1.5s ${delay}ms ease-in-out infinite`,
                  }}
                />
              ))}
            </div>
          </div>

          {/* Bottom strip */}
          <div
            className="w-full h-0.5"
            style={{
              background:
                "linear-gradient(90deg, transparent, rgba(255,238,64,0.3), transparent)",
            }}
          />
        </div>

        {/* Close button */}
        <button
          onClick={closeDialog}
          className="absolute -top-3 -right-3 z-50 rounded-full p-2 flex items-center justify-center"
          style={{
            background: "linear-gradient(135deg, #FFEE40, #f0c45a)",
            boxShadow: "0 4px 16px rgba(255,238,64,0.5)",
            width: "36px",
            height: "36px",
            border: "2px solid rgba(255,255,255,0.2)",
          }}
        >
          <img
            src={close}
            alt="close"
            style={{ width: "16px", height: "16px", filter: "brightness(0)" }}
          />
        </button>
      </div>

      <style>{`
        @keyframes dialogSlideUp {
          from { opacity: 0; transform: translateY(24px) scale(0.95); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes dotPulse {
          0%, 100% { opacity: 0.3; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.3); }
        }
      `}</style>
    </div>
  );
};

export default Dialog;
